import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Route, Routes, useParams } from 'react-router-dom';
import LegacyUserResource from '../../common/resource/LegacyUserResource';
import PeopleLayout from '../layout/PeopleLayout';
import Notes from '../../common/components/Notes';
import { UserTimesheet } from '../../projects/components/Timesheets';
import UserSkills from './UserProfile/Skills';
import UserMeetings from './UserProfile/Meetings';
import UserHealth from './UserProfile/Health';
import Performance from './UserProfile/Performance';
import UserCheckout from './UserProfile/Checkout';
import Reviews from './Reviews';
import { can } from '../../common/Util';
import Sickness from './UserProfile/Sickness';

function UserProfilePage(props) {
  const { userId } = useParams();
  const [user, setUser] = useState();

  const loadUser = async () => {
    const userData = await LegacyUserResource.get(userId);
    setUser(userData);
  };

  useEffect(() => { loadUser(); }, [userId]);

  let content;

  if (user) {
    content = <UserProfile user={user} {...props} />;
  }

  return (
    <PeopleLayout
      {...props}
      title={user ? user.name : ''}
      content={content}
    />
  );
}

function UserProfile({
  allUsers, user, activeUser, groups, csrfToken,
}) {
  const timesheetStart = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
  const timesheetEnd = moment().format('YYYY-MM-DD');

  return (
    <>
      <UserProfileTabs user={user} activeUser={activeUser} groups={groups} />

      <Routes>
        <Route path="skills" element={<UserSkills user={user} />} />

        <Route
          path="meetings"
          element={(
            <UserMeetings
              allUsers={allUsers}
              user={user}
              activeUser={activeUser}
              csrfToken={csrfToken}
            />
          )}
        />

        <Route path="health" element={<UserHealth user={user} csrfToken={csrfToken} />} />

        <Route path="checkout" element={<UserCheckout user={user} />} />

        <Route path="reviews" element={<Reviews user={user} activeUser={activeUser} />} />

        <Route path="notes" element={<Notes modelType="App\User" sessionUser={activeUser} relatedUser={user} />} />

        <Route path="timesheets" element={<UserTimesheet user={user.id} start={timesheetStart} end={timesheetEnd} />} />

        <Route path="performance" element={<Performance user={user} />} />
        <Route path="sickness*" element={<Sickness user={user} />} />
      </Routes>
    </>
  );
}

export function UserProfileTabs({ user, activeUser }) {
  const tabs = [
    { link: '', title: 'Profile', reload: true },
    { link: '/objectives', title: 'Objectives', reload: true },
    { link: '/reviews', title: 'Reviews', reload: true },
    { link: '/skills', title: 'Skills', reload: true },
  ];

  if (user.managed_by_active || user.is_viewing_self || activeUser.isOps) {
    tabs.push({ link: '/leave', title: 'Leave', reload: true });
    tabs.push({ link: '/sickness', title: 'Sickness', reload: true });
    tabs.push({ link: '/meetings', title: 'Meetings', reload: true });
    tabs.push({ link: '/notes', title: 'Notes', reload: true });
  }

  if (user.managed_by_active) {
    tabs.push({ link: '/health', title: 'Health', reload: true });
    tabs.push({ link: '/timesheets', title: 'Timesheets', reload: true });
  }

  if (user.salary_accessible_to_active) {
    tabs.push({ link: '/salary', title: 'Salary', reload: true });
  }

  if (user.is_viewing_self) {
    tabs.push({ link: '/checkout', title: 'Checkout', reload: true });
  }

  if (can('viewPerformance', user)) {
    // tabs.push({ link: '/performance', title: 'Performance' });
  }

  return (
    <ul className="nav nav-tabs mb-4">
      {tabs.map((tab) => (
        <li key={tab.link} className="nav-item">
          <UserProfileTab tab={tab} user={user} />
        </li>
      ))}
    </ul>
  );
}

function UserProfileTab({ tab, user }) {
  const path = `/users/${user.id}${tab.link}`;
  let active = false;

  if (window.location.pathname === path) {
    active = true;
  }

  return (
    <a className={`nav-link ${active ? 'active' : ''}`} href={path}>{tab.title}</a>
  );
}

export default UserProfilePage;
